import accordionSetup from "../../common/accordion.js";
import slickSlider from "../../common/slickSlider.js";
import $ from "jquery";

export default () => {
  document
    .querySelectorAll(".js-accordion-vertical")
    .forEach((elParent, indexParent) => {
      const elAccordion = elParent.querySelector(
        ".js-accordion-vertical__accordion",
      );
      const elSlider = elParent.querySelector(".js-accordion-vertical__slider");

      // Start Slider Setup
      const conf = {
        speed: 500,
        variableWidth: false,
        centerMode: true, // allows for sneak peek at prev/next slides
        dots: false,
        mobileFirst: true,
      };

      slickSlider(elSlider, conf, (event, slick) => {});

      // slick slider synthetic events require jQuery to listen.
      // gross.
      $(elSlider).on("afterChange", () => {
        // slick wants to add tabindex=-1 to all links in a slide
        // this is bad, we lose keyboard nav inside a slide.
        // delay to allow slick to make bad decisions, then fix it
        setTimeout(() => {
          elSlider
            .querySelectorAll("a")
            .forEach((link) => link.removeAttribute("tabindex"));
        }, 100);
      });
      // End Slider Setup

      // Start Accordion Setup
      const accordionItems = [];
      let activeIndex = 0;

      const toggleAccordions = (index) => {
        activeIndex = index === activeIndex ? -1 : index;
        accordionItems.forEach((item, i) => {
          item.toggleContent(i === activeIndex);
        });
      };

      elAccordion
        .querySelectorAll(".js-accordion-vertical__accordion-item")
        .forEach((el, i) => {
          const accordionItem = accordionSetup(el, i);
          accordionItems.push(accordionItem);

          const foundMedia = 
          // open this accordion if the image is clicked
          el.querySelector(".js-accordion-vertical__media")?.addEventListener(
            "click",
            (e) => {
              toggleAccordions(i);
            },
          );

          // close other accordions - only one open at a time
          el.querySelector(".js-accordion-link").addEventListener(
            "click",
            (e) => {
              toggleAccordions(i);
            },
          );
        });

      // open first accordion
      accordionItems[activeIndex].toggleContent(true);
      // End Accordion Setup

      // Keep current slide in sync
      // this feels like too much work LOE > ROI - Jonathan 7/2021
    });
};
